// Product type cards (sections/page-collection-types.liquid and
// sections/collection-types-slider.liquid): keep only the types the Boost
// filter has for each collection (Boost hides sold out products, so a type
// with only sold out products would link to an empty result) and order them
// like the Boost filter, most products first. A row with fewer cards than
// data-boost-min (default 1) is hidden. If Boost doesn't answer, the cards
// stay as rendered.
//
// Boost names the product type filter differently per collection
// (pf_pt_product_type in some, pf_pt_type in others), so the card links are
// rewritten with the name Boost returns for that collection; the Liquid only
// renders a default.
(() => {
  const BOOST_API = 'https://services.mybcapps.com/bc-sf-filter/filter';

  const boostTypes = async (shop, collectionId) => {
    const url = `${BOOST_API}?shop=${encodeURIComponent(shop)}&collection_scope=${collectionId}&limit=1&build_filter_tree=true`;
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Boost ${response.status}`);
    const data = await response.json();
    const options = (data.filter && data.filter.options) || [];
    // Product type filters are the "pf_pt_" ones.
    const typeOption = options.find((option) => String(option.filterOptionId).startsWith('pf_pt_'));
    if (!typeOption || !Array.isArray(typeOption.values)) {
      throw new Error('Boost has no product type filter for this collection');
    }
    return {
      param: typeOption.filterOptionId,
      types: typeOption.values.filter((value) => value.doc_count > 0).map((value) => value.key),
    };
  };

  // Point a card link at Boost's filter param for this collection.
  const setFilterParam = (card, param) => {
    const link = card.querySelector('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    Array.from(url.searchParams.keys())
      .filter((key) => key.startsWith('pf_pt_'))
      .forEach((key) => url.searchParams.delete(key));
    url.searchParams.set(param, card.dataset.type);
    link.href = url.pathname + url.search;
  };

  const updateRow = async (row) => {
    try {
      const { param, types } = await boostTypes(row.dataset.boostShop, row.dataset.boostCollection);
      const cards = Array.from(row.querySelectorAll('[data-type]'));
      const grid = cards.length ? cards[0].parentElement : null;

      cards.forEach((card) => setFilterParam(card, param));

      cards.forEach((card) => {
        if (!types.includes(card.dataset.type)) card.remove();
      });
      types.forEach((type) => {
        const card = cards.find((item) => item.dataset.type === type);
        if (card && card.isConnected) grid.appendChild(card);
      });

      const min = Number(row.dataset.boostMin || 1);
      if (row.querySelectorAll('[data-type]').length < min) row.style.display = 'none';

      // Slider (collection-showcase): recalculate arrows and end spacing.
      if (row.track && typeof row.update === 'function') {
        row.measureSides();
        row.fitEnd();
        row.buildDots();
        row.update();
      }
    } catch (error) {
      console.warn('[page-collection-types]', error);
    } finally {
      row.removeAttribute('data-boost-checking');
    }
  };

  const init = () => {
    document.querySelectorAll('[data-boost-collection]').forEach(updateRow);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
